import { client } from '../utils/http';

export default {
  async hasActiveCashflow(): Promise<boolean> {
    const response = await client.get('/api/partial-auth/subscription-state/has-active-cashflow');
    return response.data;
  },
};
